import { t } from '@lingui/core/macro';
import { EmptyState } from '@pocketlaw/tetris';
export function InitialState() {
    return (<EmptyState title={t({
            comment: 'Universal search - Empty search title',
            message: 'Search for anything',
        })} description={t({
            comment: 'Universal search - Empty search description',
            message: 'Then navigate results with arrow keys and hit Enter to select.',
        })} icon={undefined}/>);
}
